import { ChainId } from '@ui/types/chain';
import { BareTradePair } from '@ui/types/tradePair';

import { toPosition as toPositionV2 } from '../useGetPositionV2/toPosition';
import { ContractPositionV3, Position } from './types';

export const toPosition = ({
  position,
  chainId,
  pair,
  user,
  isPendingPosition = false,
}: {
  position: ContractPositionV3;
  chainId: ChainId;
  pair: BareTradePair;
  user?: `0x${string}`;
  isPendingPosition?: boolean;
}): Position => {
  const base = toPositionV2({
    position,
    chainId,
    pair,
    user,
    isPendingPosition,
  });

  return {
    ...base,
    earliestCloseTime: Number(position.earliestCloseTime),
  };
};


